import { defineComponent as _defineComponent } from 'vue'
import { useStore } from "@/store";
import { ActionTypes } from "@/store/action-types";
import { computed, ref } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props, { expose }) {
  expose();

const store = useStore();
const photoInput = ref(null);
const documentInput = ref(null);

const isLoading = computed(() => store.state.isLoading);
const sessionType = computed(() => store.state.sessionType);

function takePhoto() {
  (photoInput.value! as HTMLInputElement).click();
}

function scanDocument() {
  (documentInput.value! as HTMLInputElement).click();
}

async function onPhotoTaken(event: Event) {
  const file = (event.target as HTMLInputElement).files![0];
  store.dispatch(ActionTypes.PROCCESS, file);
}

async function onDocumentScanned(event: Event) {
  const file = (event.target as HTMLInputElement).files![0];
  store.dispatch(ActionTypes.PROCESSDOCUMENT, file);
}

const __returned__ = { store, photoInput, documentInput, isLoading, sessionType, takePhoto, scanDocument, onPhotoTaken, onDocumentScanned, get useStore() { return useStore }, get ActionTypes() { return ActionTypes }, computed, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})